import { TLogoStyles } from './Logo.styles';
import logoDesktop from '@/assets/buffalobet/images/logo.png';
// import logoMb from '@/assets/buffalobet/images/logoMb.png';

const styles: Partial<TLogoStyles> = {
  img: {
    src: logoDesktop,
  },
};
export default styles;
